import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        isLoggedIn: false
    },
    getters: {
        getLoggedInState: state => {
            return state.isLoggedIn;
        }
    },
    mutations: {
        initialiseStore(state) {
            if (localStorage.getItem('Store')) {
                if (localStorage.getItem('Store')) {
                    state.isLoggedIn = Boolean(localStorage.getItem('Store'));
                }
            }
        },
        setLoggedInState(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        }
    }
});

store.subscribe((mutation, state) => {
    localStorage.setItem('Store', state.isLoggedIn);
});

export default store;
